import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET } from "../../../queries/site";

const Update = (props) => {
  return (
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updatesites } }) => {
        const { sitesAll } = cache.readQuery({ query: GET });
        cache.writeQuery({
          query: GET,
          data: { sitesAll: sitesAll }
        });
      }}
      >
      {updatesites => (
       <Form query_f = {updatesites} {...props} />
      )}
    </Mutation>
    
    //<Form {...props} />
  );
};

export default Update;